import 'src/firebase'
import './utils/setDateFnsDefaults'

import 'simplebar-react/dist/simplebar.min.css'

import 'react-lazy-load-image-component/src/effects/black-and-white.css'
import 'react-lazy-load-image-component/src/effects/blur.css'
import 'react-lazy-load-image-component/src/effects/opacity.css'

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { Provider as ReduxProvider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { PersistGate } from 'redux-persist/lib/integration/react'
import { CollapseDrawerProvider } from './contexts/CollapseDrawerContext'
import { SettingsProvider } from './contexts/SettingsContext'
import { persistor, store } from './redux/store'

import App from './App'
import { invitationLinkTokenCapture } from './pages/InvitationPage/invitationLinkToken'
import { resetLinkTokenCapture } from './pages/PasswordResetPage/resetLinkToken'

// Before anything can report the address: an invitation link and a password
// reset link carry their tokens in the fragment. See `invitationLinkToken`.
invitationLinkTokenCapture()
resetLinkTokenCapture()

const container = document.getElementById('root')

if (!container) {
  throw new Error('Container for the app is not found!')
}

const root = createRoot(container)

root.render(
  <HelmetProvider>
    <ReduxProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <SettingsProvider>
            <CollapseDrawerProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </CollapseDrawerProvider>
          </SettingsProvider>
        </LocalizationProvider>
      </PersistGate>
    </ReduxProvider>
  </HelmetProvider>,
)
